// Функци From DTO берет сырые данные с бека и превращает их в данные котоые хочет видеть фронт
export function vehicleWeekMileagesFromDtoService(dto, meta) {
  const { status } = meta.response;
  return { data: dto, status };
}

export default vehicleWeekMileagesFromDtoService;
